module.exports = __webpack_public_path__ + "static/media/removeIcon.a83e981b.svg";